export default "__VITE_ASSET__c9528cde__"